interface TimeSelectGroupProps {
  hourName: string;
  minuteName: string;
  setFieldValue: (field: string, value: any) => void;
  hourValue?: number;
  minuteValue?: number;
  currentHour?: number;
  currentMinute?: number;
}
const TimeSelectGroup = ({
  hourName,
  minuteName,
  setFieldValue,
  hourValue,
  minuteValue,
  currentHour,
  currentMinute,
}: TimeSelectGroupProps) => {
  const handleHourChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setFieldValue(hourName, parseInt(e.target.value));
  };

  const handleMinuteChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setFieldValue(minuteName, parseInt(e.target.value));
  };
  return (
    <div>
      <select
        name={hourName}
        className="form-select d-inline w-auto me-2"
        value={hourValue ?? currentHour}
        onChange={handleHourChange}
      >
        {Array.from({ length: 24 }, (_, i) => (
          <option value={i} key={i}>
            {i.toString().padStart(2, "0")}
          </option>
        ))}
      </select>
      <span className="mx-1">:</span>
      <select
        name={minuteName}
        className="form-select d-inline w-auto"
        value={minuteValue ?? currentMinute}
        onChange={handleMinuteChange}
      >
        {[0, 15, 30, 45].map((m) => (
          <option value={m} key={m}>
            {m.toString().padStart(2, "0")}
          </option>
        ))}
      </select>
    </div>
  );
};

export default TimeSelectGroup;
